import type { WorkerStatus } from "@crewledger/shared/schemas";
import { cn } from "@/lib/utils";

const STYLES: Record<WorkerStatus, string> = {
  ACTIVE: "bg-green-50 text-green-700 border-green-200",
  INACTIVE: "bg-slate-100 text-slate-600 border-slate-200",
};

export function WorkerStatusBadge({ status }: { status: WorkerStatus }) {
  return (
    <span
      className={cn(
        "inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize",
        STYLES[status],
      )}
    >
      {status.toLowerCase()}
    </span>
  );
}

import { MICROCOPY } from "@/lib/microcopy";

export function PrivacyHelper() {
  return (
    <p className="rounded-lg border border-navy-blueprint/20 bg-navy-deep/5 px-3 py-2 text-sm text-navy-blueprint">
      {MICROCOPY.employeeIdPrivacy}
    </p>
  );
}
